var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("header", [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "header-left" },
          [
            _c(
              "router-link",
              { staticClass: "logo", attrs: { to: "/index" } },
              [
                _c("img", {
                  attrs: {
                    src: require("../../assets/logo.png"),
                    width: "40",
                    height: "40",
                    alt: ""
                  }
                })
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("ul", { staticClass: "nav user-menu" }, [
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "nav-item" },
            [
              _c(
                "router-link",
                { staticClass: "nav-link", attrs: { to: "/login" } },
                [_vm._v("Login")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "nav-item" },
            [
              _c(
                "router-link",
                { staticClass: "nav-link", attrs: { to: "/register" } },
                [_vm._v("Register")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown mobile-user-menu" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-menu dropdown-menu-right" },
            [
              _c(
                "router-link",
                { staticClass: "dropdown-item", attrs: { to: "/login" } },
                [_vm._v("Login")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "dropdown-item", attrs: { to: "/register" } },
                [_vm._v("Register")]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-title-box float-left" }, [
      _c("h3", [_vm._v("Dreamguy's Technologies")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c("div", { staticClass: "top-nav-search" }, [
        _c(
          "a",
          {
            staticClass: "responsive-search",
            attrs: { href: "javascript:void(0);" }
          },
          [_c("i", { staticClass: "fa fa-search" })]
        ),
        _vm._v(" "),
        _c("form", { attrs: { action: "search" } }, [
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Search here" }
          }),
          _vm._v(" "),
          _c("button", { staticClass: "btn", attrs: { type: "submit" } }, [
            _c("i", { staticClass: "fa fa-search" })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item dropdown has-arrow flag-nav" }, [
      _c(
        "a",
        {
          staticClass: "nav-link dropdown-toggle",
          attrs: { "data-toggle": "dropdown", href: "#", role: "button" }
        },
        [
          _c("img", {
            attrs: {
              src: require("../../assets/flags/us.png"),
              alt: "",
              height: "20"
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("English")])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
        _c(
          "a",
          {
            staticClass: "dropdown-item",
            attrs: { href: "javascript:void(0);" }
          },
          [
            _c("img", {
              attrs: {
                src: require("../../assets/flags/us.png"),
                alt: "",
                height: "16"
              }
            }),
            _vm._v(" English\n            ")
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "dropdown-item",
            attrs: { href: "javascript:void(0);" }
          },
          [
            _c("img", {
              attrs: {
                src: require("../../assets/flags/fr.png"),
                alt: "",
                height: "16"
              }
            }),
            _vm._v(" French\n            ")
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "dropdown-item",
            attrs: { href: "javascript:void(0);" }
          },
          [
            _c("img", {
              attrs: {
                src: require("../../assets/flags/es.png"),
                alt: "",
                height: "16"
              }
            }),
            _vm._v(" Spanish\n            ")
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "dropdown-item",
            attrs: { href: "javascript:void(0);" }
          },
          [
            _c("img", {
              attrs: {
                src: require("../../assets/flags/de.png"),
                alt: "",
                height: "16"
              }
            }),
            _vm._v(" German\n            ")
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "nav-link dropdown-toggle",
        attrs: {
          href: "#",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [_c("i", { staticClass: "fa fa-ellipsis-v" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-622c694e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-622c694e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/HeaderApp.vue
// module id = null
// module chunks = 